import type { AnalyticsPages } from '@/shared/types/analytics.types'
import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
import { TravelDirection } from '@/shared/types/common.types'

export const AnalyticsPageName = {
  RESIDENCE: 'select_country_of_residence',
  TRAVEL_DATES: 'choose_travel_dates',
  TRAVELERS: 'number_of_travellers',
  CONTACTS: 'enter_info',
  SELECT_PLAN: 'select_plan',
  HOLDER_INFO: 'holder_info',
  INSURED_PEOPLE: 'insured_people',
  QUOTE: 'your_quote',
  DOWNLOAD_POLICY: 'download_policy',
  DESTINATION: 'destination',
  UPDATE_INFORMATION: 'update_information',
  ADD_PERSON: 'add_person',
  SELECT_COUNTRY: 'select_country',
  SUCCESS_PAGE: 'success_page',
} as const

export type AnalyticsPageName = (typeof AnalyticsPageName)[keyof typeof AnalyticsPageName]

const INBOUND_ANALYTICS_PAGES: Partial<AnalyticsPages> = {
  [InboundFlowRoutes.RESIDENCE]: {
    page: AnalyticsPageName.RESIDENCE,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.DATES]: {
    page: AnalyticsPageName.TRAVEL_DATES,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.TRAVELERS]: {
    page: AnalyticsPageName.TRAVELERS,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.CONTACTS]: {
    page: AnalyticsPageName.CONTACTS,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.SELECT_PLANS]: {
    page: AnalyticsPageName.SELECT_PLAN,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.PERSONAL_INFORMATION]: {
    page: AnalyticsPageName.HOLDER_INFO,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.INSURED_TRAVELERS]: {
    page: AnalyticsPageName.INSURED_PEOPLE,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.QUOTE]: {
    page: AnalyticsPageName.QUOTE,
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.INSURANCE_RESULT]: {
    page: AnalyticsPageName.DOWNLOAD_POLICY,
    category: TravelDirection.INBOUND,
  },
}
const OUTBOUND_ANALYTICS_PAGES: Partial<AnalyticsPages> = {
  [OutboundFlowRoutes.DESTINATION]: {
    page: AnalyticsPageName.DESTINATION,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.DATES]: {
    page: AnalyticsPageName.TRAVEL_DATES,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.TRAVELERS]: {
    page: AnalyticsPageName.TRAVELERS,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.CONTACTS]: {
    page: AnalyticsPageName.CONTACTS,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.SELECT_PLANS]: {
    page: AnalyticsPageName.SELECT_PLAN,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.PERSONAL_INFORMATION]: {
    page: AnalyticsPageName.HOLDER_INFO,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.INSURED_TRAVELERS]: {
    page: AnalyticsPageName.INSURED_PEOPLE,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.QUOTE]: {
    page: AnalyticsPageName.QUOTE,
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.INSURANCE_RESULT]: {
    page: AnalyticsPageName.DOWNLOAD_POLICY,
    category: TravelDirection.OUTBOUND,
  },
}

export const ANALITYCS_PAGES: Partial<AnalyticsPages> = {
  ...INBOUND_ANALYTICS_PAGES,
  ...OUTBOUND_ANALYTICS_PAGES,
}
